<template>
  <div id="allbots">
    <div id="main">
      <div>
        <div style="min-height: 100vh;">
          <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; height: 100vh">
            <vue-particles
              color="#ffffff"
              :particleOpacity="0.27"
              :particlesNumber="24"
              shapeType="circle"
              :particleSize="3"
              linesColor="#ffffff"
              :linesWidth="1.1"
              :lineLinked="true"
              :lineOpacity="0.33"
              :linesDistance="192"
              :moveSpeed="1.6"
              :hoverEffect="false"
              :clickEffect="false"
            ></vue-particles>
          </div>
          <div class="accounts" v-show="!isLoading" style="z-index: 10">
            <v-toolbar flat color="transparent" style="background: transparent">
              <v-toolbar-title>
                <img
                  :src="$store.state.theme.small_logo"
                  class="responsive-img"
                  style="max-height:25px; margin-top: 15px; margin-left: 20px"
                  alt
                />
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <span class="mr-2" style="text-transform: capitalize;">{{
                $store.state.userid
              }}</span>
              <change-password></change-password>
              <v-btn
                flat
                fab
                icon
                small
                @click="logout"
                class="hidden-sm-and-up"
                style="line-height: 10px;"
              >
                <v-icon>power_settings_new</v-icon>
              </v-btn>
              <v-btn
                flat
                class="primary hidden-xs-only mr-4"
                style="line-height: 10px;"
                @click="logout"
                >{{ $t('Sign Out') }}</v-btn
              >
              <lang-dropdown></lang-dropdown>
            </v-toolbar>
            <div class="white" v-if="$store.state.superadmin.includes($store.state.userid)">
              <v-container class="py-2">
                <div class="caption">
                  Admin Tools
                </div>
                <v-btn class="mx-1" color="primary" @click="showManageAdmin = true"
                  >Manage Admin</v-btn
                >
                <bot-manage></bot-manage>
                <transfer-flow></transfer-flow>

                <v-dialog max-width="1000" scrollable v-model="showManageAdmin">
                  <v-card v-if="showManageAdmin">
                    <div class="text-xs-right">
                      <v-btn fab small flat @click="showManageAdmin = false"
                        ><v-icon>close</v-icon></v-btn
                      >
                    </div>
                    <v-divider></v-divider>
                    <v-card-text max-height="600">
                      <admin-setting></admin-setting>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-container>
            </div>

            <div class="text-xs-center">
              <h3 class="display-2 mt-4" style="color: white">{{ $t('Select bot to manage') }}</h3>
            </div>

            <v-container>
              <v-layout
                wrap
                justify-center
                fill-height
                class="select-page"
                style="position:relative; margin-bottom: 35px;"
                :class="{ 'no-bot': !botlist || botlist.length == 0 }"
              >
                <template v-for="bot in botlist">
                  <v-flex
                    xs6
                    sm4
                    md3
                    lg2
                    class="page pa-3"
                    :key="'bot_' + bot.pageid"
                    style="cursor: pointer; position:relative"
                  >
                    <v-responsive
                      :aspect-ratio="1 / 1"
                      class="page-image"
                      @click="onSelectedBot(bot)"
                    >
                      <img
                        @error="imgError"
                        :src="
                          'https://graph.facebook.com/' +
                            bot.pageid +
                            '/picture?width=300&height=300'
                        "
                        :alt="bot.pagename"
                        :title="bot.pagename"
                        style="width: 100%;border-radius: 10px;"
                      />
                    </v-responsive>
                    <div
                      class="page-name text-xs-center white--text mt-2 mb-2 text-truncate"
                      :title="bot.pagename"
                      @click="onSelectedBot(bot)"
                    >
                      {{ bot.pagename }}
                    </div>
                    <div
                      style="position: absolute; top: 0; right: 0;color: white; background-color: #4267B2; border-radius: 20px"
                      class="px-2 py-1 caption"
                      v-if="bot.channel == 'facebook'"
                    >
                      Facebook
                    </div>
                    <div
                      style="position: absolute; top: 0; right: 0;color: white; background-color: #06C755; border-radius: 20px"
                      class="px-2 py-1 caption"
                      v-if="bot.channel == 'line'"
                    >
                      Line
                    </div>
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import api from '@/api'
import config from '@/app-config'
import LangDropdown from '@/components/elements/LangDropdown'
import ChangePassword from './ChangePassword'
import AdminSetting from './AdminSetting.vue'
import BotManage from './BotManage.vue'
import TransferFlow from './TransferFlow.vue'

export default {
  data: function() {
    return {
      pagelist: this.$store.state.pagelist,
      isLoading: true,
      isAdd: false,
      themelist: [],
      showManageAdmin: false,
      showManagePage: false
    }
  },
  components: {
    LangDropdown,
    ChangePassword,
    AdminSetting,
    BotManage,
    TransferFlow
  },
  mounted: function() {
    let vm = this
    vm.$store.dispatch('loading')
    if (this.$store.state.superadmin.includes(this.$store.state.userid)) {
      // vm.$store.dispatch('getAllAdmins')
      // this.$store.dispatch('loadAllAdmins')
    }
    vm.getAllPublicTheme(function() {
      vm.$store.dispatch('updatePagelist')

      if (vm.isFacebook) {
        let pageidlist = []
        $.each(vm.pagelist, function(index, val) {
          if (val.perms) {
            if (val.perms.indexOf('ADMINISTER') > -1 || val.perms.indexOf('EDIT_PROFILE') > -1) {
              pageidlist.push(val.id)
            }
          }
          if (val.tasks) {
            if (val.tasks.indexOf('MANAGE') > -1 || val.tasks.indexOf('CREATE_CONTENT') > -1) {
              pageidlist.push(val.id)
            }
          }
        })
        let data = {
          userid: vm.$store.state.userid,
          pageidlist: pageidlist,
          access_token: vm.$store.state.fbAccessToken
        }
        vm.$store.dispatch('getBotlist', data).then(
          response => {
            vm.$store.dispatch('loading')
            vm.isLoading = false
            if (!vm.botlist || vm.botlist.length <= 0) {
              vm.isAdd = true
            }
          },
          error => {
            vm.$store.dispatch('loading')
            // console.log('error')
          }
        )
      } else {
        vm.$store.dispatch('loading')
        vm.isLoading = false
        if (!vm.botlist || vm.botlist.length <= 0) {
          vm.isAdd = true
        }
      }
    })
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      isFacebook: 'isFacebook',
      currentLang: 'currentLang'
    })
  },
  methods: {
    onSelectedBot: function(bot) {
      this.$store.dispatch('selectBot', bot)
      this.$router.push('flow')
    },
    logout: function() {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to Logout?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            var isFacebook = vm.isFacebook
            vm.$store.dispatch('logout', null).then()
            vm.$router.push('/' + vm.currentLang + '/login')
          }
        })
    },
    getAllPublicTheme: function(callback) {
      let vm = this
      api.getAllPublicTheme({ appid: config.appid }, function(error, response) {
        if (error) {
          console.error(error)
          return
        }

        vm.themelist = response.data
        callback()
      })
    },
    selectBot: function(pageid, event) {
      const bot = this.botlist.find(bot => {
        return bot.pageid == pageid
      })
      this.$store.dispatch('selectBot', bot)
    },
    imgError: function(event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
      // this.value.profile_pic = '/static/img/assets/livechat/profile.png'
    }
  }
}
</script>

<style lang="scss" scoped>
.v-icon {
  // line-height: 0 !important;
  height: auto !important;
}
.select-page {
  .page {
    transition: transform 0.3s ease-out;

    &:hover {
      transform: translate(0, -5px);

      .page-image img {
        box-shadow: 0px 3px 5px #00000021;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/allbots/Account.vue